export const moduleName = 'cookies';

export default {
  SET_COOKIES_SETTINGS_OPEN: `${moduleName}/SET_COOKIES_SETTINGS_OPEN`,
  SET_GLOBAL_COOKIES_SETTINGS_ICON_SHOWN: `${moduleName}/SET_GLOBAL_COOKIES_SETTINGS_ICON_SHOWN`,
};
